import { SecondaryPagination } from "@hatch-digital-nl/abs-storybook/legacy";
import { setCurrentPage, setItemsPerPage } from "../ReviewSlice";
import React, { JSX } from "react";
import { CertificateInterface } from "../../../common/interfaces/CertificateInterface";
import { useAppDispatch } from "../../../app/hooks";
import { MetaInterface } from "../../../common/interfaces/MetaInterface";

interface Props {
    itemsPerPage: number;
    certificates: {
        data: CertificateInterface[];
        meta?: MetaInterface;
    };
    currentPage: number;
    itemsPerPageSelect: {
        value: number;
        activeValue: boolean;
    }[];
}

export const ReviewPagination = (props: Props): JSX.Element => {
    const { itemsPerPage, certificates, currentPage, itemsPerPageSelect } =
        props;
    const dispatch = useAppDispatch();

    return (
        <div className={"p-review__pagination"}>
            {Boolean(itemsPerPage && certificates?.meta) && (
                <SecondaryPagination
                    itemsPerPage={itemsPerPage}
                    totalItems={certificates?.meta?.total || 0}
                    currentPage={currentPage}
                    onPaginationChange={(page: number) =>
                        dispatch(setCurrentPage(page))
                    }
                    totalItemsOnCurrentPage={certificates?.data.length || 0}
                    onItemsPerPageChange={(
                        event: React.ChangeEvent<HTMLSelectElement>,
                    ) => dispatch(setItemsPerPage(Number(event.target.value)))}
                    itemsPerPageSelect={itemsPerPageSelect}
                />
            )}
        </div>
    );
};
